import * as actions from '../Actions/Kinds';

export const kindsReducer = (state = {}, action) => {
    switch (action.type) {
        case actions.GET_KINDS_DATA_REQUESTED:
            return {...state, isLoading: true};
        case actions.GET_KINDS_DATA_DONE:
            return {...state, isLoading: false, kinds: action.payload};
        case actions.GET_KINDS_DATA_FAILED:
            return {...state, isLoading: false, isError: true, error: action.payload};
        case actions.SAVE_NEW_KIND_DATA_REQUEST:
            return {...state, isLoading: true};
        case actions.SAVE_NEW_KIND_DATA_SUCCESS:
            return {...state, isLoading: false, kinds: [...state.kinds, action.payload]};
             case actions.SAVE_NEW_KIND_DATA_FAILED:
                 return {...state, isLoading: false, isError: true, error: action.payload};
             case actions.UPDATE_KIND_DATA_REQUEST:
                 return {...state, isLoading: true};
             case actions.UPDATE_KIND_DATA_SUCCESS:
                 return {
                     ...state, isLoading: false, kinds: state.kinds.map((kind) => {
                         if (kind.entryId === action.payload.entryId) {
                             kind.active = action.payload.active;
                             return kind;
                         }
                         return kind
                     })
                 };
             case actions.UPDATE_KIND_DATA_FAILED:
                 return {...state, isLoading: false, isError: true, error: action.payload};
             default:
                 return state;
         }
    };